export default __webpack_public_path__ + "static/media/img_self_service_banner.ce2d25a1.png";